module.exports = __webpack_public_path__ + "assets/media/day36.5659c9c4.mp3";